var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4467_69287)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9998 8.00156C6.23249 8.00156 4.7998 6.56887 4.7998 4.80156C4.7998 3.03425 6.23249 1.60156 7.9998 1.60156C9.76712 1.60156 11.1998 3.03425 11.1998 4.80156C11.1998 6.56887 9.76712 8.00156 7.9998 8.00156Z",
    fill: "#FBA12B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.40039 14.1016C2.40039 14.2696 2.53592 14.4016 2.70842 14.4016H13.2924C13.4649 14.4016 13.6004 14.2696 13.6004 14.1016C13.6004 11.6176 11.0869 9.60156 8.00039 9.60156C4.91392 9.60156 2.40039 11.6176 2.40039 14.1016Z",
    fill: "#FBA12B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4467_69287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMember);
export default __webpack_public_path__ + "static/media/Member.b508f53b96eedc8ede4e4827c593870a.svg";
export { ForwardRef as ReactComponent };